import './CollectionTreeWrapper.css'

import * as React from 'react';
import { Tree } from 'antd';
import { treeCollectionsMapping } from '../../treemappings';

const { TreeNode } = Tree;

export default function CollectionTreeWrapper({ restrictedCollectionIds, selectedCollectionIds, updateFilterState, setQuery }: any) {

  const displayNode = (itemKey: number) => {
    return { display: restrictedCollectionIds.indexOf(itemKey + '') > -1 ? 'none' : '' };
  };

  const disableNode = (itemKey: number) => {
    return restrictedCollectionIds.indexOf(itemKey + '') > -1;
  };

  const renderTreeNodes = (data: any) => data.map((item: any) => {
    const inlineStyle = displayNode(item.key);
    const disabled = disableNode(item.key);
    if (item.children) {
      return (
        <TreeNode title={item.title} key={item.key} dataRef={item} style={inlineStyle} disabled={disabled}>
          {renderTreeNodes(item.children)}
        </TreeNode>
      );
    }
    return <TreeNode {...item} key={item.key} style={inlineStyle} disabled={disabled}/>;
  });

  const onCheck = (checkedKeys: []) => {
    let query: Object = {};
    if (checkedKeys && checkedKeys.length > 0) {
      query = {
        query: {
          bool: {
            'must': [{ 'bool': { 'must': [{ 'bool': { 'should': [{ 'terms': { 'collectionId.keyword': checkedKeys } }] } }] } }]
          }
        }
      };
    } else {
      query = {
        query: {
          'match_all': {}
        }
      };
    }

    setQuery({
      query,
      value: checkedKeys
    });
    updateFilterState(checkedKeys);
  };

  React.useEffect(() => {
    onCheck(selectedCollectionIds);
  }, [selectedCollectionIds]);

  return (
    <Tree
      checkable={true}
      onCheck={onCheck}
      defaultExpandedKeys={['-9']}
      checkedKeys={selectedCollectionIds}
      className="collectionLabel"
      style={{overflowX: 'auto'}}
    >
      {renderTreeNodes(treeCollectionsMapping)}
    </Tree>
  );
};



// WEBPACK FOOTER //
// ./src/components/search/CollectionTreeWrapper.tsx